import { Boolean, Null, Number, Static, String, Union } from "runtypes";

import { DynamicList, NumberArray, StringArray } from "./parameterValueType.js";
import { TableInputData } from "./tableInputTypes.js";

// This is identical to `ParameterValueContents` in `@hex/common`, except for the
// exclusion of `DatetimeValue`, which are represented as strings of the form expected
// by `parseDatetimeQueryParam` in `ParameterValue.repository.ts
export const ParameterQueryParamValue = Union(
  String,
  Boolean,
  Null,
  Number,
  StringArray,
  NumberArray,
  DynamicList,
  TableInputData,
);
export type ParameterQueryParamValue = Static<typeof ParameterQueryParamValue>;
